/**
 * Metadatos documentales de la lámina: fechas, código de documento y formato de
 * superficie. Todo recibe la fecha por parámetro para poder testearse.
 */

const MESES = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

/** "Agosto 2026" — la fecha de elaboración que va en el cajetín y el pie. */
export function monthYear(date = new Date()) {
  return `${MESES[date.getMonth()]} ${date.getFullYear()}`;
}

/** Superficie en la forma "12.345 m² · 1,23 ha", con separadores chilenos. */
export function formatArea(areaM2) {
  const squareMeters = Math.round(areaM2);
  const hectares = (areaM2 / 10000).toFixed(2).replace('.', ',');
  return `${squareMeters.toLocaleString('es-CL')} m² · ${hectares} ha`;
}

/** Código autogenerado del documento: "VH-L01-2026 · v1". */
export function autoDocCode(sheetNumber = 'L-01', version = 'v1', date = new Date()) {
  const sheet = String(sheetNumber).replace(/[^A-Za-z0-9]/g, '');
  return `VH-${sheet}-${date.getFullYear()} · ${version}`;
}

/** Nombre de archivo seguro derivado del código de documento y el sitio. */
export function exportFileName(docCode, siteName, fallback = 'proyecto') {
  const code = (docCode || '').replace(/[^\w-]+/g, '_');
  const site = (siteName || '').replace(/[^\w]+/g, '_');
  return (
    [code, site]
      .filter(Boolean)
      .join('_')
      .replace(/_+/g, '_')
      .replace(/^_|_$/g, '') || fallback
  );
}
